import React from 'react';
import PropTypes from 'prop-types';
import Collapsible from 'react-smooth-collapse';
import _isEmpty from 'lodash/isEmpty';
import _trim from 'lodash/trim';
import cn from 'classnames';

import './style.scss';

const Annotation = ({ name, token, color, features, isExpanded }) => (
  <div styleName={cn('item', { 'is-expanded': !isExpanded })}>
    <div data-test="annotated-entity-name" style={{ color }} styleName="name">
      {name}
    </div>
    <Collapsible expanded={isExpanded}>
      <div data-test="annotated-entity-feature" styleName="feature">
        covered text<span>=</span>
        <b>{`"${token}"`}</b>
      </div>
      {!_isEmpty(features) &&
        Object.entries(features).map(([key, value]) => (
          <div
            key={key}
            data-test="annotated-entity-feature"
            styleName="feature"
          >
            {_trim(key)}
            <span>=</span>
            <b>{value !== '' ? value : '-'}</b>
          </div>
        ))}
    </Collapsible>
  </div>
);

Annotation.propTypes = {
  color: PropTypes.string,
  features: PropTypes.shape({
    value: PropTypes.string,
  }),
  isExpanded: PropTypes.bool,
  name: PropTypes.string,
  token: PropTypes.string,
};

export default Annotation;
